"use strict"

export function initInScope($scope) {

    $("body").on("submit", ".js-combined-article-form", function(e){
/*         e.preventDefault();
        console.log(e); */
    //    $(this).trigger();
    });
    $("body").on("click", ".js-variant-select__combined", function(e){
        $(".js-variant-select-input__combined-number").prop('disabled', true);
        $(this).closest('.js-variant-select-input__combined-number--selected').prop('disabled', true);
        $(this).find('.js-variant-select-input__combined-number').prop('disabled', false);
    });
    $("body").on("click", ".js-combined-select__remove", function(e){
        $(this).parent().find(".js-variant-select-input__combined-number--selected").prop('disabled', true);
        $(this).parent().parent().find('.variant-dropdown__menu').find('input').each(function(){
            $(this).prop('disabled', true);
        });
        $(".js-variant-select-input__combined-number").prop('disabled', true);

        const $form = $('.js-combined-article-form');
        const urlParams = new URLSearchParams(window.location.search);
        const currentFilter = urlParams.get('accfilter');

        $form.find('input[name="accfilter"]').remove();

        if (currentFilter) {
            $('<input>').attr({
                type: 'hidden',
                name: 'accfilter',
                value: currentFilter
            }).appendTo($form);
        }
        
        $form.trigger('submit');
    });
    $scope.find(".js-variant-select__combined").each(function () {
      //  $scope.find(".js-variant-select-input__combined-number").prop('disabled', true);
     //   $(this).find('.js-variant-select-input__combined-number').prop('disabled', false);
    });

    $scope.find(".js-variant-select-input__combined-number--selected").each(function () {
        $(this).on("change", function(){
            let name = $(this).attr('name');
            $('input[name="'+name+'"][type="hidden"]').val($(this).val());
        });
    });

        $scope.find(".js-variant-select").each(function () {
        let $variantSelection = $(this);

        $variantSelection.find('.js-variant-select__remove').on('click', function () {
            let target = $($(this).data('target-id'));
            target.prop('checked', false)
            target.trigger('change')
        });
    });

    function applyAccessoryFilter($filterContainer, filterValue) {
        const $variantSelect = $filterContainer.next('.js-variant-select');
        const $dropdown = $variantSelect.find('.variant-dropdown');
        const $dropdownBtn = $dropdown.find('.dropdown-toggle');
        const $accessories = $variantSelect.find('.dropdown-menu .js-variant-select__combined');
        const $addButton = $variantSelect.next().find('.js-add-filtered-accessories');
        
        let visibleCount = 0;
        $accessories.each(function() {
              const category = $(this).data('accessory-category');
              // Case-insensitive comparison
              if (category && category.toLowerCase() === filterValue.toLowerCase()) {
                  $(this).show();
                  visibleCount++;
              } else {
                  $(this).hide();
              }
          });
      
            if (visibleCount > 0) {
                $addButton.show().attr('data-filter-category', filterValue);
            } else {
                $addButton.hide();
            }
        
        if (visibleCount === 0) {
            $dropdownBtn.prop('disabled', true).addClass('disabled');
        } else {
            $dropdownBtn.prop('disabled', false).removeClass('disabled');
        }
        
        const $configLinks = $variantSelect.find('.js-config-link');
        $configLinks.each(function() {
            const $link = $(this);
            const linkCategory = $link.data('filter-category');
            
            if (linkCategory && linkCategory.toLowerCase() === filterValue.toLowerCase()) {
                $link.show();
            } else {
                $link.hide();
            }
        });
    }
    
    $('.variant-dropdown__filters').each(function() {
        const $filterContainer = $(this);
        const urlParams = new URLSearchParams(window.location.search);
        let currentFilter = urlParams.get('accfilter');
        
        if (!currentFilter) {
            const $firstFilter = $filterContainer.find('.js-accessory-filter').first();
            if ($firstFilter.length) {
                currentFilter = $firstFilter.data('filter');
                $firstFilter.addClass('active');
            }
        } else {
            $filterContainer.find('.js-accessory-filter').each(function() {
                if ($(this).data('filter') === currentFilter) {
                    $(this).addClass('active');
                }
            });
        }
        
        if (currentFilter) {
            applyAccessoryFilter($filterContainer, currentFilter);
        }
    });
    
    $("body").on("click", ".js-accessory-filter", function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const $button = $(this);
        const filterValue = $button.data('filter');
        const $filterContainer = $button.closest('.variant-dropdown__filters');
        
        $filterContainer.find('.js-accessory-filter').removeClass('active');
        $button.addClass('active');
        
        const url = new URL(window.location);
        url.searchParams.set('accfilter', filterValue);
        window.history.pushState({}, '', url);
        
        applyAccessoryFilter($filterContainer, filterValue);
    });
    
    function calculateAccessoryQuantity($input) {
        const $variantSelect = $input.closest('.js-variant-select');
        const maxProductsData = $variantSelect.data('max-products');
        
        if (!maxProductsData) {
            return;
        }
        
        const mainProductQuantity = parseInt($('.js-main-product-quantity').val()) || 1;
        
        let accessoryId = $input.data('accessory-id');
        if (!accessoryId) {
            const $parent = $input.closest('label, div[data-id]');
            accessoryId = $parent.data('id');
        }
        
        if (!accessoryId || !maxProductsData[accessoryId]) {
            return;
        }
        
        const maxProductsPerAccessory = maxProductsData[accessoryId];
        const minRequiredAccessoryQty = Math.ceil(mainProductQuantity / maxProductsPerAccessory);
        const currentAccessoryQty = parseInt($input.val()) || 0;
        
        if (currentAccessoryQty < minRequiredAccessoryQty) {
            $input.val(minRequiredAccessoryQty);
        }
    }
    
    $('body').on('change input', '.js-variant-select-input__combined-number, .js-variant-select-input__combined-number--selected', function() {
        calculateAccessoryQuantity($(this));
    });
    
    $('body').on('change', '.js-variant-select-input__combined-number, .js-variant-select-input__combined-number--selected', function() {
        calculateAccessoryQuantity($(this));
    });
    
    $('body').on('change input keyup', '.js-main-product-quantity', function() {
        $('.js-variant-select-input__combined-number, .js-variant-select-input__combined-number--selected').each(function() {
            calculateAccessoryQuantity($(this));
        });
    });
    
    $(document).on("ready" , function() {
        $('.js-variant-select-input__combined-number--selected').each(function() {
            calculateAccessoryQuantity($(this));
        });
    });
}